<template>
    <div
      aria-expanded="false"
      class="v-treeview-node v-treeview-node--leaf v-treeview-node--click"
    >
      <div class="v-treeview-node__root">
        <div class="v-treeview-node__level"></div>
        <button
          type="button"
          class="v-icon notranslate v-treeview-node__checkbox v-icon--link mdi" :class="selected ? 'mdi-checkbox-marked theme--light primary--text' : 'mdi-checkbox-blank-outline theme--light'"
          @click="selectItem"
        ></button>
        <div class="v-treeview-node__content">
          <div class="v-treeview-node__label">{{ item.name }}</div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
    name: 'TreeItem',
    props: {
        selected: {
            type: Boolean,
            'default': false
        },
        item: {
            type: Object,
            'required': true
        }
    },
    methods: {
        selectItem () {
            this.$emit('select', this.item);
        }
    }
};
</script>
